export default {
    getActivitySectorList: {
        error: null,
        loading: false,
        data: [],
    }
}